import React from 'react';
import { Button, Modal } from 'zarm';
import { Upload } from '@iyunbao/components';
import LockScroll from '../../lockScroll';

function UploadModal(props) {
  const { fileUrl, visible, onChange, ...rest } = props;

  const onSelectFile = (file) => {
    if (!file) {
      return null;
    }

    const callbackObj = {
      type: 'fileUpload',
      data: file,
    };

    onChange(callbackObj);
  };

  // 关闭弹窗
  const onClose = () => {
    const callbackObj = {
      type: 'close',
    };

    onChange(callbackObj);
  };

  return (
    <LockScroll>
      <Modal width="100%" className="upload-modal-wrap" visible={visible} maskClosable>
        <div className="upload-modal">
          <img className="upload-modal-img" src={fileUrl} alt="" />
        </div>
        <div className="btn-group">
          <Button onClick={() => onClose()} size="sm" className="btn-group-item2" shape="round">
            关闭
          </Button>
          <Upload {...rest} onChange={(file) => onSelectFile(file)}>
            <Button className="btn-group-item1" size="sm" shape="round">
              重新上传
            </Button>
          </Upload>
        </div>
      </Modal>
    </LockScroll>

  );
}

export default UploadModal;
